import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ChatView } from "@/components/messenger";

export const Route = createFileRoute("/_app/messenger/$id")({
	component: MessengerChat,
});

function MessengerChat() {
	const { id } = Route.useParams();
	const navigate = useNavigate();

	const handleBack = () => {
		navigate({ to: "/messenger" });
	};

	return <ChatView conversationId={id} onBack={handleBack} />;
}
